import React from "react";
import { Dimmer, Loader } from "semantic-ui-react";
export default () => (
  <Dimmer style={{ height: "100%" }} inverted active>
    <Loader>Loading...</Loader>
  </Dimmer>
);
